/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/facebook_medium'
export default icon
